import React from "react";
import PropTypes from "prop-types";
import * as styles from "./styles.module.css";
import Markdown from "react-markdown";

class ConsentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      acceptResponse: this.props.acceptResponse,
      declineResponse: this.props.declineResponse,
    };
  }

  render() {
    return (
      <div className={styles.rectangle}>
        <div className={styles.consentOption}>
          <div>
            <input
              type="radio"
              className={styles.radio}
              name="userConsent"
              value="acceptConsent"
              onChange={this.props.onConsentAccept}
            />
          </div>
          <label className={styles.label}>
            <Markdown
              children={this.state.acceptResponse}
              components={{
                a: ({ node, ...props }) => (
                  <a {...props} target="_blank" rel="noopener noreferrer" />
                ),
              }}
            />
          </label>
        </div>
        <div className={styles.consentOption}>
          <div>
            <input
              type="radio"
              className={styles.radio}
              name="userConsent"
              value="declineConsent"
              onChange={this.props.onConsentDecline}
            />
          </div>
          <label className={styles.label}>
            <Markdown
              children={this.state.declineResponse}
              components={{
                a: ({ node, ...props }) => (
                  <a {...props} target="_blank" rel="noopener noreferrer" />
                ),
              }}
            />
          </label>
        </div>
      </div>
    );
  }
}

ConsentForm.propTypes = {
  acceptResponse: PropTypes.string.isRequired,
  declineResponse: PropTypes.string.isRequired,
  onConsentAccept: PropTypes.func.isRequired,
  onConsentDecline: PropTypes.func.isRequired,
};

export default ConsentForm;
